import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { Clock, Phone } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { SERVICES, PHONE_TEL } from "../data/content";

const ServiceCard = ({ s, i }) => {
  const Icon = Icons[s.icon] || Icons.Sparkles;
  return (
    <Reveal delay={(i % 3) * 0.1} className="h-full">
      <motion.article
        whileHover={{ y: -8 }}
        transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
        className="group relative flex h-full flex-col overflow-hidden rounded-[1.6rem] border border-sage/10 bg-white shadow-[0_2px_10px_-6px_rgba(27,41,33,0.15)] transition-shadow duration-500 hover:shadow-[0_30px_60px_-30px_rgba(62,92,75,0.45)]"
        data-testid={`service-card-${s.id}`}
      >
        <div className="relative h-52 overflow-hidden">
          <img
            src={s.image}
            alt={s.title}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-110"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-ink/60 to-transparent" />
          <span className="absolute left-5 top-5 flex h-11 w-11 items-center justify-center rounded-full bg-cream/90 text-sage backdrop-blur">
            <Icon className="h-5 w-5" />
          </span>
        </div>
        <div className="flex flex-1 flex-col p-7">
          <h3 className="font-serif text-2xl leading-tight text-ink">{s.title}</h3>
          <p className="mt-3 flex-1 text-sm leading-relaxed text-muted">{s.desc}</p>
          <div className="mt-5 flex flex-wrap gap-2">
            {s.tags.map((t) => (
              <span key={t} className="rounded-full bg-sage-pale px-2.5 py-1 text-[11px] font-semibold text-sage">
                {t}
              </span>
            ))}
          </div>
          <div className="mt-6 flex items-center justify-between border-t border-sage/10 pt-5">
            <span className="inline-flex items-center gap-1.5 text-xs text-muted">
              <Clock className="h-3.5 w-3.5" /> {s.duration}
            </span>
            <a
              href={PHONE_TEL}
              className="inline-flex items-center gap-1 text-sm font-semibold text-sage transition-colors hover:text-gold"
              data-testid={`service-call-btn-${s.id}`}
            >
              <Phone className="h-3.5 w-3.5" /> Chiama per prenotare
            </a>
          </div>
        </div>
        <span className="absolute inset-x-0 bottom-0 h-[3px] origin-left scale-x-0 bg-gold transition-transform duration-500 group-hover:scale-x-100" />
      </motion.article>
    </Reveal>
  );
};

export const Services = () => (
  <section id="servizi" className="relative bg-beige-light py-24 md:py-36" data-testid="services-section">
    <div className="container-x">
      <div className="flex flex-col gap-10 md:flex-row md:items-end md:justify-between">
        <SectionHeading
          id="services"
          eyebrow="I Nostri Servizi"
          title={<>Trattamenti pensati <em className="font-normal italic text-sage">per te</em>, non per tutti.</>}
        />
        <Reveal delay={0.2} className="max-w-sm text-sm leading-relaxed text-muted md:text-right">
          Ogni percorso viene definito insieme, dopo una consulenza gratuita in centro. Chiamaci per informazioni e per fissare il tuo appuntamento.
        </Reveal>
      </div>
      <div className="mt-16 grid gap-7 sm:grid-cols-2 lg:grid-cols-3">
        {SERVICES.map((s, i) => (
          <ServiceCard key={s.id} s={s} i={i} />
        ))}
      </div>
    </div>
  </section>
);
